import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createTicketsSlice = (set, get) => ({
    tickets: {
        loading: false,
        data: [],
    },
    getTickets: async (params) => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ tickets: { ...state.tickets, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: 'get',
                baseURL: config.apiUrls(),
                url: `/v1/business/tickets/${params.id}/${params.fromDate}/${params.toDate}/${params.isTicket}`,
                headers: { token }
            });
            set(state => ({ tickets: { loading: false, data: resp.data } }));
        } catch (error) {
            set(state => ({ tickets: { loading: false, data: [] } }));
        }
    }
});
